export default __webpack_public_path__ + "static/media/github-logo.4f357cea.svg";